import { Publisher } from '../model/publisher.class';
import { Model } from '../model/model.class';

export class Media extends Model {

  public mediaId: number;
  public coverUrl = ' <img src="http://bookii-streamingservice.de/files/2/9998/9998_en.png" height="42" width="42"> ';

  constructor(
    public mid: number,
    public title: string,
    public volume: number,
    public author: string,
    public url: string,
    public thumbMD5: string,
    public fileMD5: string,
    public bookAreaCode: string,
    public isbn: string,
    public ean: string,
    public publishDate: Date,
    public lasModificationDate: Date,
    public articleNo: string,
    public shortDescribtion: string,
    public describtion: string,
    public mediaType: string,
    public mediaStatus: string,
    public versionCount: number,
    public publisher: Publisher,
    public oidsPerUnit: number
  ) {super(); }
}



// WEBPACK FOOTER //
// ./src/app/model/media.class.ts